"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnGrid = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const Grid_1 = require("../../Grid");
require("../types");
const GridRoot_1 = require("./GridRoot");
const Root = styled_components_1.default(components_1.StackView).attrs({
    direction: components_1.STACK_DIRECTION.column,
}) `
  flex: 1 0 0;
  height: 100%;
`;
Root.displayName = 'Root';
function ColumnGrid({ id, idKey, title, selected, data, displayField, loading, onSelect, onRowDoubleClick, dataState, setDataState, searchRenderer, actionsRenderer, rowHeight, cellRenderer, isRowDisabled, subheaderRenderer, }) {
    return (react_1.default.createElement(Root, { gap: components_1.STACK_GAP.m },
        id === 'availableGrid'
            ? searchRenderer === null || searchRenderer === void 0 ? void 0 : searchRenderer(dataState, setDataState)
            : actionsRenderer === null || actionsRenderer === void 0 ? void 0 : actionsRenderer(dataState, setDataState),
        react_1.default.createElement(Root, { gap: components_1.STACK_GAP.s },
            react_1.default.createElement(components_1.Text, null, title),
            react_1.default.createElement(GridRoot_1.GridRoot, null,
                react_1.default.createElement(Grid_1.Grid, { id: id, idKey: idKey, hasHeader: false, height: components_1.GRID_HEIGHT_MODE.auto, showCheckbox: false, loading: loading, selectionMod: Grid_1.GRID_SELECTION_MOD.multi, selected: selected, data: data || [], columns: [{ field: displayField, cell: cellRenderer }], onSelect: (selectedItems) => {
                        onSelect(selectedItems);
                    }, onRowDoubleClick: onRowDoubleClick, rowHeight: rowHeight, isRowDisabled: isRowDisabled, subheaderRenderer: subheaderRenderer })))));
}
exports.ColumnGrid = ColumnGrid;
ColumnGrid.displayName = 'ColumnGrid';
//# sourceMappingURL=ColumnGrid.js.map